import React, { useState } from 'react';
import Box from '@mui/material/Box';
import Divder from '../../Components/CommonComp/Divder';
import CustomBox from '../../Components/CommonComp/CustomBox/CustomBox';
import AdminLogsUserList from '../../Components/AdminLogs/AdminLogsUserList';

function AdminLogsUsers({handleNavParams}) {

return (
    <Box
      component="main"
      sx={(theme) => {
        return {
          flexGrow: 1,
        };
      }}
    >
      <CustomBox padding={0}>
        <AdminLogsUserList/>
      </CustomBox>
      <Divder spacing={1.2} />
    </Box>
  );
}

export default AdminLogsUsers;



